interface Props {
  errorText: string
}
const FormikErrorText = ({ errorText }: Props) => {
  return <p className='text-red-500 ml-1 mt-1 text-sm'>{errorText}</p>
}

export default FormikErrorText
